import { render, staticRenderFns } from "./BrandProducts.vue?vue&type=template&id=027ef08c&scoped=true&"
import script from "./BrandProducts.vue?vue&type=script&lang=js&"
export * from "./BrandProducts.vue?vue&type=script&lang=js&"
import style0 from "./BrandProducts.vue?vue&type=style&index=0&id=027ef08c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027ef08c",
  null
  
)

export default component.exports